import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {take} from 'rxjs/operators';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {KeycloakHelper} from '~/app/shared/helpers/keycloak-helper';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {AuthServicesService} from 'mclane-webauth-lib';
import {Invoice} from "~/app/core/common/models/invoice";
import {DialogHelperComponent, DialogType} from "~/app/shared/helpers/dialog-helper";
import {ToastService} from '~/app/shared/helpers/toast-service';
@Component({
    selector: 'app-invoicelist-dialog',
    templateUrl: './invoicelist-dialog.component.html',
    styleUrls: ['./invoicelist-dialog.component.scss']
})
export class InvoicelistDialogComponent implements OnInit {
    
    @Input()
    title: string;
    @Input()
    type: string;
    @Input()
    public width = 0;
    @Input()
    public height = 0;
    message: string;
    list: Invoice[] = [];
    @Input()
    public opened = false;
    @Output()
    public closed = new EventEmitter<string>();

    response: any;
    missing: string;
    pdf: string;

    constructor(private _keycloakHelper: KeycloakHelper,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                public dialogHelper: DialogHelperComponent,
                public storeListService: StoreListService,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                public auth: AuthServicesService,
                private toaster: ToastService
            ) {
        this.opened = false;
    }

    ngOnInit(): void {
    }

    public open(type: string,
                title: string,
                message: string,
                cancel: string,
                confirm: string,
                minWidth: number,
                width: number,
                minHeight: number,
                height: number,
                list: any): Promise<any> {
        this.type = type;
        this.title = title;
        this.width = width;
        this.height = height;
        this.message = '';
        this.list = list;
        this.opened = true;
        return this.closed.asObservable()
            .pipe(take(1))
            .toPromise();
    }

    public close(invoice: any) {
        this.opened = false;
        if (invoice !== 'close') {
            this.showInvoice(invoice).then(() => {
            });
        }
        this.closed.emit(invoice);
    }

    async getInvoices(invoice) {
        await this.storeListService.getInvoices(invoice)
            .toPromise()
            .then(r => {
                if(r === null || r === undefined) {
                    this.toaster.showToastWarning('No Invoices for ' + this.storeListService.pickedStore.identity +' '+ invoice, '', 3500)
                } else {
                    this.response = r;
                    this.response = this.response.trim();
                    let s = this.response.charAt(0);
                    if (s >= '0' && s <= '9') {
                        this.missing = this.response.replace(/,/g, "");
                        this.dialogHelper.open(
                            {
                                type: DialogType.WARNING,
                                title: 'Missing Invoices',
                                content: 'Not able to access ' + this.missing,
                                actions: [
                                    {text: 'Ok', themeColor:"primary"}
                                ],
                                width: 400
                            });
                    } else {
                        let someString = this.response.toString();
                        let index = someString.indexOf(' ');
                        if (index == -1) {
                            index = someString.length;
                            this.pdf = someString.substr(0, index);
                        } else {
                            this.pdf = someString.substr(0, index);
                            this.missing = someString.substr(index + 1);
                            this.missing = this.missing.slice(0, -1);
                            if (typeof this.pdf != 'undefined' && this.pdf) {
    
                                this.dialogHelper.open(
                                    {
                                        type: DialogType.WARNING,
                                        title: 'Missing Invoices',
                                        content: 'Invoices ' + this.missing + ' are missing from pdf.',
                                        actions: [
                                            {text: 'Ok', themeColor:"primary"}
                                        ],
                                        width: 400
                                    });
                            }
                        }
                        let binary_string = window.atob(this.pdf);
                        let len = binary_string.length;
                        let bytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                            bytes[i] = binary_string.charCodeAt(i);
                        }
                        let file = new Blob([bytes.buffer], {type: 'application/pdf'});
                        let fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }
                }
            });
    }

    async showInvoice(invoice: Invoice) {
        await this.getInvoices(invoice.invoiceNumber);
    }
}
